import { Box, BoxProps } from '@material-ui/core';
import { ReactNode } from 'react';

import { Loading } from '@/components/modules/Application/components/_shared/components/Loading';
import { useScreen } from '@/hooks/useScreen';

interface SectionProps extends BoxProps {
  loading?: boolean;
  shadow?: boolean;
  disableAnimation?: boolean;
  children?: ReactNode;
}

export const Section = ({
  loading = false,
  shadow = false,
  disableAnimation = false,
  children,
  ...boxProps
}: SectionProps) => {
  const { sm } = useScreen();

  return (
    <Box
      display={'flex'}
      height={'100%'}
      width={'100%'}
      className={`${!disableAnimation && 'appear-anim'} ${shadow && !sm && 'box-shadow-gradient'}`}
      {...boxProps}
    >
      <Box flexGrow={1} maxWidth={'100%'} position={'relative'}>
        {loading ? <Loading /> : children}
      </Box>
    </Box>
  );
};
